import React, { useEffect, Fragment, useContext } from 'react';
import { useInput } from '../../../utils/useInput';
import { useHistory } from 'react-router-dom';
import { putAPI } from '../../../api/api-method';
import { USER_API } from '../../../api/api-url';
import { Text, Button } from 'prixa-design-kit/dist';
import { ResetPasswordContext } from './ResertPasswordContext';

export const ResetPasswordForm = () => {
  const { setError, isLoad, setLoader } = useContext(ResetPasswordContext);
  const [isValid, setIsValid] = React.useState(false);

  const password = useInput({
    label: 'Password',
    type: 'password',
    placeholder: 'Tulis Password',
    errMessage: 'Password harus mengandung huruf kapital, kecil, angka dan minimal 8 karakter',
  });

  const confirmPassword = useInput({
    label: 'Konfirmasi Password',
    type: 'password',
    placeholder: 'Tulis Password',
    confirmWith: password.value,
  });

  const inputList = [password.input, confirmPassword.input];
  const history = useHistory();

  useEffect(() => {
    const isPasswordValid = password.value && !password.error;
    const isConfirmPasswordValid = confirmPassword.value && !confirmPassword.error;
    isPasswordValid && isConfirmPasswordValid ? setIsValid(true) : setIsValid(false);
  }, [password, confirmPassword]);
  /* eslint-enable */

  const resetPassword = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    setLoader(true);
    putAPI(USER_API.FORGET_PASSWORD, {
      forgetPasswordToken: String(window.location.pathname).split('password/')[1],
      password: password.value,
      confirmPassword: confirmPassword.value,
      diagnosticSessionID: localStorage.getItem('DiagnosisID'),
    })
      .then(() => {
        setLoader(false);
        history.push('/reset-password-sent');
      })
      .catch(err => {
        setError(err.response.data.error);
        setTimeout(() => {
          setError('');
        }, 3000);
        setLoader(false);
      });
  };

  return (
    <Fragment>
      <div className="prixa-title margin-baseB">
        <Text scale="question">Masukkan password baru untuk akun Anda.</Text>
      </div>
      <div className="margin-baseB">
        <Text scale="caption">
          Pastikan password mengandung huruf kapital, huruf kecil, angka, dan berjumlah minimal 8 karakter
        </Text>
      </div>
      <form onSubmit={(event: React.FormEvent<HTMLFormElement>): void => resetPassword(event)}>
        {inputList.map((item, key: number) => {
          return (
            <div key={key} className="margin-baseB">
              {item}
            </div>
          );
        })}
        <div className="text-center margin-largeT">
          <Button
            onClick={(e: any) => resetPassword(e)}
            size="xLarge"
            variant="primary"
            disabled={!isValid}
            loading={isLoad}
          >
            Ganti password
          </Button>
        </div>
      </form>
    </Fragment>
  );
};
